import {
  type CreateValues,
  type FindAllOptions,
  type PracticeConfigApiInstance,
  type UpdateValues,
} from '../../models/orchestrator/practiceConfig/apiInstance.js';
import { type PaginatedQueryOptions } from '../../models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from '../../models/pagination/PaginationResponse.type.js';
import OrchestratorAPI from '../common.js';

export default class API extends OrchestratorAPI {
  public readonly API_PATH = '/practice-config-api-instances';
  public readonly baseEndpoint = `${this.BASE_URL}${this.API_PATH}`;

  async findAll(options: FindAllOptions = {}): Promise<PracticeConfigApiInstance[]> {
    const url = this.constructPath('/', options);
    const { practiceConfigApiInstances } = await this.common.getJSON(url);
    return practiceConfigApiInstances.map(this.deserialize);
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<PracticeConfigApiInstance>> {
    const url = this.constructPath('/', options);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<PracticeConfigApiInstance> {
    const url = this.constructPath(`/${id}`);
    const { practiceConfigApiInstance } = await this.common.getJSON(url);
    return this.deserialize(practiceConfigApiInstance);
  }

  async create(values: CreateValues): Promise<PracticeConfigApiInstance> {
    const url = this.constructPath('/');
    const { practiceConfigApiInstance } = await this.common.postJSON(url, values);
    return this.deserialize(practiceConfigApiInstance);
  }

  async remove(id: string): Promise<void> {
    const url = this.constructPath(`/${id}`);
    return await this.common.deleteJSON(url);
  }

  async update(id: string, values: UpdateValues): Promise<PracticeConfigApiInstance> {
    const url = this.constructPath(`/${id}`);
    const { practiceConfigApiInstance } = await this.common.patchJSON(url, values);
    return this.deserialize(practiceConfigApiInstance);
  }
}
